export { default } from './SpeedDial';